import moment from "moment";
import paginationComponent from "../../../components/pagination/pagination.component";
import { formats as FORMATS } from '../../../config/constants';
import languageModel from "../../../models/language.model";
import ValidationFailOver10PercentModel from "../../../models/validation-fail/validation-fail-over-ten-percent/validation-fail-over-ten-percent.model";
import ViewBase from "../../view-base.view";

/**
 * Validation fail over 10% view
 * 
 * A page that displays a list of validation fail over 10%
 * 
 * @author cmc.pbhieu
 */

export default function ValidationFailOver10PercentView() {
  ViewBase.call(this);

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
  };

  const LOG_TYPE = {
    User: 'FAIL_INPUTUSER',
    Channel: 'FAIL_CHANNEL'
  };

  const EXCEL_TYPE = {
    total: 'TOTAL',
    fail: 'FAIL',
    success: 'SUCCESS'
  }

  const DEFAULT_FILTERS = {
    type: LOG_TYPE.User,
    logWeek: moment().format(FORMATS.API_WEEK_FORMAT),
  };

  let filters = structuredClone(DEFAULT_FILTERS);
  let pagination = structuredClone(DEFAULT_PAGINATION);
  let validationLogs = [];

  let currentFilters = structuredClone(DEFAULT_FILTERS);

  const getFilterParams = (param) => {
    return {
      type: param.type,
      logWeek: param.logWeek,

      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
    };
  };

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;

    getTableData();
  };

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    getTableData();
  };

  const clearFilter = () => {
    filters = structuredClone(DEFAULT_FILTERS);
  };

  const handleDownloadSpecificFile = (excelType, objectCd) => {
    this.showLoading();

    const downloadParams = {
      excelType,
      objectCd,
      logType: currentFilters.type,
      logWeek: currentFilters.logWeek,
    };

    ValidationFailOver10PercentModel.downloadSpecificExcel(downloadParams)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const search = (e) => {
    if (!this.validateForm(e)) {
      return false;
    }

    pagination = structuredClone(DEFAULT_PAGINATION);
    currentFilters = structuredClone(filters)
    getTableData();
  }

  const getTableData = () => {
    this.showLoading();

    ValidationFailOver10PercentModel.search(getFilterParams(currentFilters))
      .then(result => {
        validationLogs = [];

        if (result) {
          validationLogs = result.data;
          pagination.totalItems = result.total;
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const downloadExcel = () => {
    this.showLoading();

    ValidationFailOver10PercentModel.downloadExcel(getFilterParams(currentFilters))
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const SpecificCellComponent = () => {
    return {
      view: ({ attrs: { excelType, objectCd, cellData } }) =>
        cellData > 0
          ? m('a.btn.btn-link.p-0',
            {
              onclick: (e) => {
                e.preventDefault();
                handleDownloadSpecificFile(excelType, objectCd);
              },
              role: 'button',
              href: '#',
            }, cellData)
          : cellData
    };
  };

  return {
    view: () => {
      return [
        m(".d-flex.flex-column.align-items-end.gap-2.mb-3",
          m(".card.collapse.show#search-section.w-100",
            m(".card-body",
              m("form.row.mb-2.g-4.needs-validation[novalidate]",
                {
                  onsubmit: search,
                },
                m(".col-xl-3.col-lg-4.col-sm-6.position-relative.gap-2",
                  m('label.form-label.mandatory[for="datePicker"]', this.getText("LT00000337", "Week")),
                  m('input#datePicker.form-control[type="week"][required]', {
                    value: filters.logWeek ? moment(filters.logWeek, FORMATS.API_WEEK_FORMAT).format(FORMATS.WEEK_FORMAT) : null,
                    onchange: (e) => {
                      filters.logWeek = e.target.value ? moment(e.target.value, FORMATS.WEEK_FORMAT).format(FORMATS.API_WEEK_FORMAT) : null;
                    }
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                ),

                m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                  m('.col-md-12', m('label.form-label[for="log-type-form"]', this.getText('LT00000117', 'Type'))),

                  m('div#log-type-form',
                    m('.form-check.form-check-inline',
                      m('input.form-check-input#log-type-user[type="radio"][name="inputType"]',
                        {
                          checked: filters.type == LOG_TYPE.User,
                          onclick: () => {
                            filters.type = LOG_TYPE.User;
                          }
                        }),
                      m('label.form-check-label[for="log-type-user"]', this.getText("LT00001154", "by Input User"))
                    ),
                    m('.form-check.form-check-inline',
                      m('input.form-check-input#log-type-channel[type="radio"][name="inputType"]',
                        {
                          checked: filters.type == LOG_TYPE.Channel,
                          onclick: () => {
                            filters.type = LOG_TYPE.Channel;
                          }
                        }),
                      m('label.form-check-label[for="log-type-channel"]', this.getText("LT00001153", "by Channel"))
                    )
                  )
                ),

                m(".col-xl-6.col-lg-6.col-sm-6.d-flex.align-items-end.justify-content-end.gap-2",
                  m("button.btn.btn-primary",
                    {
                      type: 'submit'
                    },
                    this.getText("LT00000001", "Search")
                  ),

                  m("button.btn.btn-white",
                    {
                      onclick: clearFilter,
                    },
                    this.getText("LT00000031", "Clear")
                  )
                )
              ),
            )
          )
        ),
        ///* TABLE */
        m(".card",
          m(".card-body",
            m(".row.g-2",
              m(".col-12",
                m(".col-12.d-flex.justify-content-end",
                  m(".d-flex.gap-2",
                    m("button.btn.btn-primary",
                      {
                        onclick: downloadExcel,
                        disabled: validationLogs == null || validationLogs.length == 0
                      },
                      m("i.bi.bi-file-earmark-arrow-down-fill"),
                      this.getText("LT00000018", "Excel Download")
                    )))),
              m(".col-12",
                m(".table-responsive",
                  m("table.table.table-hover.sticky-column-start",
                    m("thead",
                      m("tr.align-middle",
                        m("th.center",
                          { colspan: 2 },
                          currentFilters.type === LOG_TYPE.Channel
                            ? this.getText("LT00001152", "Input Channel")
                            : this.getText("LT00001151", "Input User")),
                        m("th.center", this.getText("LT00001155", "Total Upload Count")),
                        m("th.center", this.getText("LT00001156", "Fail Count")),
                        m("th.center", this.getText("LT00001157", "Fail Rate")),
                        m("th.center", this.getText("LT00001158", "Success Count")),
                      )
                    ),
                    m("tbody",
                      validationLogs.length == 0 &&
                      m("tr.align-middle",
                        m("td.text-center",
                          { colspan: "21" },
                          languageModel.getText(
                            "EM00000141",
                            "No records found."
                          )
                        )
                      ),
                      validationLogs.length != 0 && validationLogs.map((data) =>
                        m(`tr.align-middle`,
                          m("td", m("span.cursor-text", data.objectCd)),
                          m("td", m("span.cursor-text", data.objectName)),
                          m("td.center",
                            m("span.cursor-tex",
                              m(SpecificCellComponent, {
                                objectCd: data.objectCd,
                                cellData: data.totalCount,
                                excelType: EXCEL_TYPE.total
                              }))),
                          m("td.center",
                            m("span.cursor-text",
                              m(SpecificCellComponent, {
                                objectCd: data.objectCd,
                                cellData: data.count,
                                excelType: EXCEL_TYPE.fail
                              }))),
                          m("td.center", m("span.cursor-text", data.rate)),
                          m("td.center",
                            m("span.cursor-text",
                              m(SpecificCellComponent, {
                                objectCd: data.objectCd,
                                cellData: data.etcCount,
                                excelType: EXCEL_TYPE.success
                              })))
                        )
                      )
                    )
                  )
                )
              ),
              validationLogs.length != 0 &&
              m(".col-12",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  onPageChanged: onPageChanged,
                  onPageSizeChanged: onPageSizeChanged,
                })
              )
            )
          )
        ),
        this.getBaseViews()
      ]
    }
  }
}